var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import AdminHeader from '@/modules/admin/components/AdminHeader.vue';
import UsersTable from '@/modules/admin/components/UsersTable.vue';
import AdminEmpty from '@/modules/admin/components/AdminEmpty.vue';
import UsersTableSkeleton from '@/modules/admin/components/UsersTableSkeleton.vue';
import Pagination from 'components/Pagination.vue';
import { disableJivo } from '@/shared/utils/helpers';
import { disableUser, enableUser, fetchAllUsers } from '@/clients/admin';
import { NotificationService } from '@/services/NotificationService';
let AdminContainer = class AdminContainer extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.searchTerm = '';
        this.searchSuperlogicaId = '';
        this.userRoles = [];
        this.usersStatus = [];
        this.userTypeAccount = [];
        this.usersCategory = [];
        this.usersCs = [];
        this.firstCreditAge = [];
        this.csAndAdmins = [];
        this.users = [];
        this.totalUsers = 0;
        this.pageNumber = 1;
        this.perPage = 10;
        this.percentage = 1;
        this.totalClients = 50;
    }
    async mounted() {
        await this.fetchUsers();
        disableJivo(undefined, true);
    }
    showAccountInfo(user) {
        this.$store.dispatch('admin/select_account', { accountId: user.account_id });
        this.$store.dispatch('admin/select_user', { userId: user.id });
        this.$store.dispatch('admin/update_left_tab_of_modal', 'credits');
    }
    setPageNumber(pageNumber) {
        if (pageNumber !== this.pageNumber) {
            this.pageNumber = pageNumber;
            this.fetchUsers();
        }
    }
    get totalPages() {
        return Math.ceil(this.totalUsers / this.perPage);
    }
    async confirmRevoke(user) {
        try {
            await disableUser(user.id);
            const index = this.users.findIndex(u => u.id == user.id);
            this.users[index].active = false;
            NotificationService.success('Sucesso', 'Usuário desabilitado com sucesso!');
        }
        catch (e) {
            NotificationService.error('Erro', 'Aconteceu algo inesperado e não foi possível desabilitar este usuário.');
        }
    }
    async confirmActive(user) {
        try {
            await enableUser(user.id);
            const index = this.users.findIndex(u => u.id == user.id);
            this.users[index].active = true;
            NotificationService.success('Sucesso', 'Usuário habilitado com sucesso!');
        }
        catch (e) {
            NotificationService.error('Erro', 'Aconteceu algo inesperado e não foi possível habilitar este usuário.');
        }
    }
    async searchUsersByNameOrEmail(term) {
        this.searchTerm = term;
        this.pageNumber = 1;
        this.fetchUsers();
    }
    async searchBySuperlogicaId(superlogicaId) {
        this.searchSuperlogicaId = superlogicaId;
        this.pageNumber = 1;
        this.fetchUsers();
    }
    async changePerPage(perPage) {
        this.perPage = perPage;
        this.pageNumber = 1;
        await this.fetchUsers();
    }
    async searchUsersbyCheckbox(event) {
        await this.buildFilters(event);
        this.pageNumber = 1;
        this.fetchUsers();
    }
    async buildFilters(filters) {
        filters.forEach(element => {
            if (element.label === 'Tipo da Conta') {
                this.userTypeAccount = [];
                element.items.forEach(item => {
                    if (item.isSelected) {
                        this.userTypeAccount.push(item.value);
                    }
                });
            }
            if (element.label === 'Tipo do Usuário') {
                this.userRoles = [];
                element.items.forEach(item => {
                    if (item.isSelected) {
                        this.userRoles.push(item.value);
                    }
                });
            }
            if (element.label === 'Status do Usuário') {
                this.usersStatus = [];
                element.items.forEach(item => {
                    if (item.isSelected) {
                        this.usersStatus.push(item.value);
                    }
                });
            }
            if (element.label == 'Categoria do Usuário') {
                this.usersCategory = [];
                element.items.forEach(item => {
                    if (item.isSelected) {
                        this.usersCategory.push(item.value);
                    }
                });
            }
            if (element.label == 'CS do Usuário') {
                this.usersCs = [];
                element.items.forEach(item => {
                    if (item.isSelected) {
                        this.usersCs.push(item.value);
                    }
                });
            }
            if (element.label == 'Tempo de assinatura') {
                this.firstCreditAge = [];
                element.items.forEach(item => {
                    if (item.isSelected) {
                        this.firstCreditAge.push(item.value);
                    }
                });
            }
        });
    }
    async fetchUsers() {
        this.loading = true;
        try {
            const response = await fetchAllUsers({
                page: this.pageNumber,
                per_page: this.perPage,
                search: this.searchTerm,
                roles: this.userRoles,
                statuses: this.usersStatus,
                types: this.userTypeAccount,
                superlogica_id: this.searchSuperlogicaId,
            });
            this.users = response.data.users;
            this.totalUsers = response.data.total;
        }
        catch (e) {
            NotificationService.error('Erro', 'Aconteceu algo inesperado e não foi possível listar os usuários');
        }
        this.loading = false;
    }
};
AdminContainer = __decorate([
    Component({
        name: 'AdminContainer',
        components: {
            AdminHeader,
            UsersTable,
            AdminEmpty,
            Pagination,
            UsersTableSkeleton,
        },
    })
], AdminContainer);
export default AdminContainer;
